export default __webpack_public_path__ + "static/media/marvilop.62068642.png";